import * as faq from './FaqActions';

export default { ...faq };
